import React from 'react'

const Artist = (props) => (
  <div
    css={{
      background: '#171717',
      color: '#cfcfcf',
      textAlign: 'center',
      padding: '20px',
      margin: '0 10px 0 10px',
      'border': '1px solid grey',
      ':hover': { background: '#333333' },
    }}
  >
    <a href={props.sc_url} target="new" css={{
      textDecoration: 'none',
      color: '#cfcfcf',
      fontFamily: 'Roboto, sans-serif',
      fontSize: '20px',
    }}>
      <img src={props.img_url} style={{ height: '250px', width: '250px' }}/>
      <div>{props.name}</div>
    </a>
  </div>
)

export default Artist



// WEBPACK FOOTER //
// ./src/components/artist.js